// extracted by mini-css-extract-plugin
export var fadeIn = "_e4-1";
export var modalContent = "_e4-3";
export var overlay = "_e4-0";
export var popoverContent = "_e4-2";
export var results = "_e4-5";
export var searchInputWrapper = "_e4-4";